export const COUNTRIES: string[] = [
  'Andorra',
  'United Arab Emirates',
  'Afghanistan',
  'Antigua and Barbuda',
  'Anguilla',
  'Albania',
  'Armenia',
  'Angola',
  'Antarctica',
  'Argentina',
  'American Samoa',
  'Austria',
  'Australia',
  'Aruba',
  'Åland',
  'Azerbaijan',
  'Bosnia and Herzegovina',
  'Barbados',
  'Bangladesh',
  'Belgium',
  'Burkina Faso',
  'Bulgaria',
  'Bahrain',
  'Burundi',
  'Benin',
  'Saint Barthélemy',
  'Bermuda',
  'Brunei',
  'Bolivia',
  'Bonaire',
  'Brazil',
  'Bahamas',
  'Bhutan',
  'Bouvet Island',
  'Botswana',
  'Belarus',
  'Belize',
  'Canada',
  'Cocos [Keeling] Islands',
  'Democratic Republic of the Congo',
  'Central African Republic',
  'Republic of the Congo',
  'Switzerland',
  'Ivory Coast',
  'Cook Islands',
  'Chile',
  'Cameroon',
  'China',
  'Colombia',
  'Costa Rica',
  'Cuba',
  'Cape Verde',
  'Curacao',
  'Christmas Island',
  'Cyprus',
  'Czech Republic',
  'Germany',
  'Djibouti',
  'Denmark',
  'Dominica',
  'Dominican Republic',
  'Algeria',
  'Ecuador',
  'Estonia',
  'Egypt',
  'Western Sahara',
  'Eritrea',
  'Spain',
  'Ethiopia',
  'Finland',
  'Fiji',
  'Falkland Islands',
  'Micronesia',
  'Faroe Islands',
  'France',
  'Gabon',
  'United Kingdom',
  'Grenada',
  'Georgia',
  'French Guiana',
  'Guernsey',
  'Ghana',
  'Gibraltar',
  'Greenland',
  'Gambia',
  'Guinea',
  'Guadeloupe',
  'Equatorial Guinea',
  'Greece',
  'South Georgia and the South Sandwich Islands',
  'Guatemala',
  'Guam',
  'Guinea-Bissau',
  'Guyana',
  'Hong Kong',
  'Heard Island and McDonald Islands',
  'Honduras',
  'Croatia',
  'Haiti',
  'Hungary',
  'Indonesia',
  'Ireland',
  'Israel',
  'Isle of Man',
  'India',
  'British Indian Ocean Territory',
  'Iraq',
  'Iran',
  'Iceland',
  'Italy',
  'Jersey',
  'Jamaica',
  'Jordan',
  'Japan',
  'Kenya',
  'Kyrgyzstan',
  'Cambodia',
  'Kiribati',
  'Comoros',
  'Saint Kitts and Nevis',
  'North Korea',
  'South Korea',
  'Kuwait',
  'Cayman Islands',
  'Kazakhstan',
  'Laos',
  'Lebanon',
  'Saint Lucia',
  'Liechtenstein',
  'Sri Lanka',
  'Liberia',
  'Lesotho',
  'Lithuania',
  'Luxembourg',
  'Latvia',
  'Libya',
  'Morocco',
  'Monaco',
  'Moldova',
  'Montenegro',
  'Saint Martin',
  'Madagascar',
  'Marshall Islands',
  'Macedonia',
  'Mali',
  'Myanmar [Burma]',
  'Mongolia',
  'Macao',
  'Northern Mariana Islands',
  'Martinique',
  'Mauritania',
  'Montserrat',
  'Malta',
  'Mauritius',
  'Maldives',
  'Malawi',
  'Mexico',
  'Malaysia',
  'Mozambique',
  'Namibia',
  'New Caledonia',
  'Niger',
  'Norfolk Island',
  'Nigeria',
  'Nicaragua',
  'Netherlands',
  'Norway',
  'Nepal',
  'Nauru',
  'Niue',
  'New Zealand',
  'Oman',
  'Panama',
  'Peru',
  'French Polynesia',
  'Papua New Guinea',
  'Philippines',
  'Pakistan',
  'Poland',
  'Saint Pierre and Miquelon',
  'Pitcairn Islands',
  'Puerto Rico',
  'Palestine',
  'Portugal',
  'Palau',
  'Paraguay',
  'Qatar',
  'Réunion',
  'Romania',
  'Serbia',
  'Russia',
  'Rwanda',
  'Saudi Arabia',
  'Solomon Islands',
  'Seychelles',
  'Sudan',
  'Sweden',
  'Singapore',
  'Saint Helena',
  'Slovenia',
  'Svalbard and Jan Mayen',
  'Slovakia',
  'Sierra Leone',
  'San Marino',
  'Senegal',
  'Somalia',
  'Suriname',
  'South Sudan',
  'São Tomé and Príncipe',
  'El Salvador',
  'Sint Maarten',
  'Syria',
  'Swaziland',
  'Turks and Caicos Islands',
  'Chad',
  'French Southern Territories',
  'Togo',
  'Thailand',
  'Tajikistan',
  'Tokelau',
  'East Timor',
  'Turkmenistan',
  'Tunisia',
  'Tonga',
  'Turkey',
  'Trinidad and Tobago',
  'Tuvalu',
  'Taiwan',
  'Tanzania',
  'Ukraine',
  'Uganda',
  'U.S. Minor Outlying Islands',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vatican City',
  'Saint Vincent and the Grenadines',
  'Venezuela',
  'British Virgin Islands',
  'U.S. Virgin Islands',
  'Vietnam',
  'Vanuatu',
  'Wallis and Futuna',
  'Samoa',
  'Kosovo',
  'Yemen',
  'Mayotte',
  'South Africa',
  'Zambia',
  'Zimbabwe',
];

export const AU_STATES_CODE = [
  {
    value: 'NSW',
    label: 'NSW',
  },
  {
    value: 'ACT',
    label: 'ACT',
  },
  {
    value: 'QLD',
    label: 'QLD',
  },
  {
    value: 'NT',
    label: 'NT',
  },
  {
    value: 'SA',
    label: 'SA',
  },
  {
    value: 'TAS',
    label: 'TAS',
  },
  {
    value: 'VIC',
    label: 'VIC',
  },
  {
    value: 'WA',
    label: 'WA',
  },
];

export const LABELS = {
  DWELLING_TYPE: 'Dwelling type',
  OCCUPANCY_STATUS: 'Occupancy status',
  UNIMPROVED_VALUE: 'Unimproved value',
  STREET_NUMBER: 'Street number',
  STREET_NAME: 'Street name',
  SUBURB: 'Suburb',
  STATE: 'State',
  POSTCODE: 'Postcode',
  UNIT_NUMBER: 'Unit number',
  HOME_ADDRESS: 'Home address',
  INSTALLATION_ADDRESS: 'Installation address',
  MANUAL_ADDRESS: 'Enter address manually',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  MIDDLE_NAME: 'Middle name',
  PASSPORT_NUMBER: 'Passport number',
  ISSUING_COUNTRY: 'Issuing country',
  DATE_OF_BIRTH: 'Date of birth',
  EXPIRY_DATE: 'Expiry date',
  IDENTIFICATION_TYPE: 'Identification type',
  MEDICARE_NUMBER: 'Medicare card number',
  MEDICARE_REFERENCE: 'Individual ref number',
  LICENCE_NUMBER: 'Licence number',
  LICENCE_CARD_NUMBER: 'Card number',
  PHOTO_ID_NUMBER: 'ID number',
  INCOME_TYPE: 'Primary income type',
  EMPLOYER_NAME: "Employer's business name",
  EMPLOYER_PHONE_NUMBER: "Employer's phone number",
  JOB_TITLE: 'Job title',
  INCOME_AFTER_TAX: 'Primary income after tax',
  NET_INCOME: 'Net income',
  ADDITIONAL_INCOME: 'Additional income',
  ADDITIONAL_INCOME_AFTER_TAX: 'Additional income after tax',
  TRADING_NAME: 'Trading name/ABN',
  BUSINESS_PHONE_NUMBER: 'Business phone number',
  RETIRED_OR_PENSIONER: 'Retired or pensioner',
  OTHER: 'Other',
  ACCOUNT_HOLDER: 'Account holder name',
  BSB: 'BSB',
  ACCOUNT_NUMBER: 'Account number',
  MARITAL_STATUS: 'Relationship status',
  DEPENDANTS: 'Dependants',
  PARTNER_INCOME: 'Partner income after tax',
  MORTGAGE_REPAYMENTS: 'Mortgage repayments',
  RENT: 'Rent',
  OTHER_LOANS: 'Other loans',
  CREDIT_CARDS: 'Credit cards',
  HOUSE_LIVING_EXPENSES: 'Household living expenses',
  EMAIL: 'Email',
  MOBILE_NUMBER: 'Mobile number',
  PHONE_NUMBER: 'Phone number',
  PROOF_ID: 'Proof of ID',
  OWNERSHIP_PERCENTAGE: 'Ownership percentage',
  EMAIL_ADDRESS: 'Email address',
  CORPORATE_ENTITIES_LABEL: 'Corporate entities associated with the business',
  NUMBER_OF_DIRECTORS_LABEL: 'Number of Directors',
};

export const ENTERPRISE_PARTNER = {
  COMMBANK: 'commbank',
  REWIRING_AU: 'rewiring-au',
  BRIGHTE: 'brighte',
  RACQ: 'racq',
};

export const FINANCIAL_PRODUCT = {
  ACT_SHS: 'act-shs-loan',
  TAS_ESLS: 'tas-esls-loan',
  ACT_SLIP: 'act-slip-loan',
  BGL: 'brighte-green-loan',
  BPL: 'brighte-personal-loan',
  ACT_SFA: 'act-solar-for-apartments-loan',
  FLEX: 'brighte-flex',
  ELECTRIFY_2515: 'electrify-2515',
  CBA_PARTNER: 'cba-partner',
  CBA_RESIDENTIAL: 'commbank-residential',
  BRIGHTE_PAY: 'brighte-pay',
  HEUF_LOAN: 'brighte-heuf-green-loan',
  SME: 'brighte-business',
  ACT_COMMUNITY: 'act-community-loan',
  BHESL: 'brighte-home-energy-saver-loan',
};

export const GOVERNMENT_FINANCIAL_PRODUCTS = [
  FINANCIAL_PRODUCT.ACT_SFA,
  FINANCIAL_PRODUCT.ACT_SHS,
  FINANCIAL_PRODUCT.ACT_SLIP,
  FINANCIAL_PRODUCT.TAS_ESLS,
];

export const BUSINESS_LOAN_PRODUCTS = [FINANCIAL_PRODUCT.SME, FINANCIAL_PRODUCT.ACT_COMMUNITY];

export const isBusinessLoanProduct = (financialProductId?: string): boolean =>
  !!financialProductId && BUSINESS_LOAN_PRODUCTS.includes(financialProductId);

export const APPLICATION_ID_LENGTH = 8;
export const DOCUMENT_ID_LENGTH = 36;

// for s3 service and file validation schema
export const MAX_FILE_SIZE_BYTES = 15728640; // 15 MB
export const MEGA_BYTE_TO_BYTE = 1048576;
export const MIN_FILE_SIZE_BYTES = 1024; // 1 KB
export const VALID_FILE_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png'];

export const PENSIONER_CODE_REQUIRED_INCOME_VERIFICATION = '2';
export const PENSIONER_CODE_NOT_REQUIRED_INCOME_VERIFICATION = '1';

export const E2515_CASH_APPLICATION_ANNUAL_INCOME_THRESHOLD = 78000;
export const BNPL_REQUIRE_INCOME_VERIFICATION_FINANCE_AMOUNT_THRESHOLD = 40000;

export enum UPDATE_APPLICATION_ACTION {
  ADD_JOINT = 'add-joint',
  WITHDRAW = 'withdraw',
}
